$('.js-faq-question').each(function() {
	const $faqQuestion = $(this);
	const $faqItem = $faqQuestion.parents('.js-faq-item');
	const $faqAnswer = $faqItem.find('.js-faq-answer');

	$faqQuestion.on('click', function(e) {
		e.preventDefault;
		$faqItem.toggleClass('is-active');
		$faqAnswer.slideToggle(300);
	});
});


window.theme = window.theme || {};


  theme.Modals = (function() {

    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };

      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      //$(this.config.open).on('click', this.open.bind(this));
      $("body").on('click', this.config.open, this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));

      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
    
    Modal.prototype.open = function(evt) {
       
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;
 

      $('body')
      .trigger('productModalOpen')
      .trigger('modalOpen.' + this.id);

      setTimeout(function() {
        var var_this = $(".modal--quick-shop.modal--is-active .product__photos_js");
        var color_handle = $(".modal--quick-shop.modal--is-active input[name='Color']:checked").attr("data-color-name-handle");
        var color_no_handle = $(".modal--quick-shop.modal--is-active input[name='Color']:checked").attr("data-color-name");
        if ( color_no_handle != undefined ) {
          func_Change_Color_Slider (var_this, color_handle, color_no_handle);
        }
        
      }, 10);


      this.bindEvents();
    };

    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function() {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 550); // modal close css transition

      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;
 

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));

        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  })();



(function() {
	var loyaltyDigitalCardModal = new theme.Modals('DigitalCardModal', 'digital-card-modal', {
		closeOffContentClick: true,
		solid: true
	});
})();

// swipe functionality for collection products on mobile
(function() {
	const gap = 50;
	let touchstartX = 0;
	let touchstartY = 0;
	let touchendX = 0;
	let touchendY = 0;

	function handleGesture(e) {
		const diffX = touchstartX - touchendX;
		const diffY = touchstartY - touchendY;

		if (Math.abs(diffX) > Math.abs(diffY)) {
			const $productGridItem = $(e.target).parents('.collection_item');
			const $buttonPrev = $productGridItem.find('.carousel__arrow--left-z_F');
			const $buttonNext = $productGridItem.find('.carousel__arrow--right-Max');

			if (diffX > gap) { // swipe left
				$buttonNext.trigger('click');
			} else if (diffX < -gap) { // swipe right
				$buttonPrev.trigger('click');
			}
		}
	}

	$(document).on('touchstart', '.js-product-grid-item-images', e => {
		touchstartX = e.changedTouches[0].screenX
		touchstartY = e.changedTouches[0].screenY
	})

	$(document).on('touchend', '.js-product-grid-item-images', e => {
		touchendX = e.changedTouches[0].screenX
		touchendY = e.changedTouches[0].screenY
		handleGesture(e)
	})

})();


// handle products in PickyStory app widgets
(function() {
	function picky_custom_func () {
		const $bundleProducts = $('[class*="_picky-product-card-container_"]');
		$bundleProducts.each(function (index, product) {
			const $productLink = $(product).find('[href*="/products/"]');
			const $productButton = $(product).find('.picky-add-to-cart-button');
			let data_text = false;
	
				// check for preorders
				const productUrl = $productLink.attr('href').split('?')[0] + '.js';
				jQuery.getJSON(productUrl, function(product) {
					if (product.tags.includes('preorder')) {
						data_text = $productButton.find(':last').text();
						$productButton.find(':last').attr("data-text", data_text);
						$productButton.find(':last').text('Pre-Order');
					}
				})
				.fail(function() {
				  //console.log( "error" );
				  $productButton.find(':last').text('Not available');
				  $productButton.find(':last').attr("data-text", 'Not available');
				  $productButton.prop( "disabled", true ); 
				});
	
				// temp kludge for ajax cart event
				$productButton.parent().on('click', function() {
					setTimeout(function () {
						
						// This code has been moved to theme.js for stability. Look for the variable "el_picky_button"
						//$('body').trigger('added.ajaxProduct');
 
						$('[data-text="Not available"]').parent('.picky-add-to-cart-button').prop( "disabled", true ); 
						$('[data-text="Out of stock"]').parent('.picky-add-to-cart-button').prop( "disabled", true ); 
					}, 1000);
				});

				// Save "Out of stock" text
				setTimeout(function () {
					if ( data_text ) {
						$(product).find('.picky-add-to-cart-button[disabled="disabled"]').find(':last').text( data_text ); 
					}
				}.bind(this), 2000);
		});
	}

	// Check Start App 
	function picky_custom_func_check() {
		if ( $('[class*="_picky-product-card-container_"]').length ) {
			picky_custom_func();
		} else {
			setTimeout(function () {
				picky_custom_func_check();
			}.bind(this), 1000);
		}
	}
	/*if ( theme.settings.handle == 'shop-the-look' ) {
		picky_custom_func_check();
	}*/

})();












(function() {
  if ( window.location.search.indexOf('?customerId=') !== -1  ) {

    // get URL DATA
    var gets = (function() {
      var a = window.location.search;
      var b = new Object();
      a = a.substring(1).split("&");
      for (var i = 0; i < a.length; i++) {
        c = a[i].split("=");
        b[c[0]] = c[1];
      }
      return b;
    })();
    console.log(gets.customerId);

    $.ajax({
      type: 'GET',
      url: 'https://67s.89c.coniq.com/api/loyaltyshowcustomer?id='+gets.customerId,
      data: {},
      dataType: "json",
      complete: function (data) {   
        if ( data.responseText.indexOf('Notice') === -1 ) {
          json = JSON.parse(data.responseText);
          console.log(json);
		  console.log('================='); 
		   var tiers = json[1][0].tier.label;
            if(tiers=='Platinum'){
           document.getElementById('final').style.display='none';
            }

          var customer = json[0].customer;
          var name = customer.first_name + " " + customer.last_name; 
          var barcode = json[2][0].barcode_number;
          var currentBalance = json[1][0].current_balance
          var barcodeImage = json[2][0].images.f1D;
          var tierName = json[1][0].tier.label;

          
          document.querySelector("p.c-loyalty-main__title-name").textContent = name;
          document.querySelector("#barcode").textContent = barcode;
          document.querySelector("#points_balance").textContent = currentBalance;
          document.querySelector("#barcode_image").src=barcodeImage;
          document.querySelector("#tier").textContent = tierName;
          
          /*
          let html = $('.loyalty_noCustomer_all').html();
          html = html.replace( /__NAME__/g , json[0].customer.first_name+" "+json[0].customer.last_name); 
          //html = html.replace( /__NAME__/g , json[0].customer.last_name); 
          html = html.replace( /__NUMBER__/g , json[2][0].barcode_number ? json[2][0].barcode_number : ''); 
          html = html.replace( /__BALANCE__/g , json[1][0].lifetime_balance ? json[1][0].lifetime_balance : '0'); 
         
          // let tiers = 'Platinum';
          console.log(tiers);
          //let tier_array = ['Silver','Gold','Platinum'];
          //  let tier = document.getElementById("tier");
          // tier.innerHTML = tiers;
          switch(tiers){
              case 'Silver':
              var currentTierName = json.tiers ? json.tiers.toLowerCase() : 'silver';
               var file_url = $('[data-fileUrl]').attr("data-fileUrl").replace("silver.jpg", currentTierName +'.jpg').replace("silver_300x.jpg", currentTierName +'.jpg');
              //console.log("s"+file_url);
                html = html.replace( /__IMG_CART__/g , file_url); 
              break;
               case 'Gold':
               currentTierName = json.tiers ? json.tiers.toLowerCase() : 'gold';
                file_url = $('[data-fileUrl]').attr("data-fileUrl").replace("silver.jpg", currentTierName +'.jpg').replace("silver_300x.jpg", currentTierName +'.jpg');
             // console.log("g"+file_url);
                html = html.replace( /__IMG_CART__/g , file_url); 
              break;
               case 'Platinum':
               currentTierName = json.tiers ? json.tiers.toLowerCase() : 'platinum';
                file_url = $('[data-fileUrl]').attr("data-fileUrl").replace("silver.jpg", currentTierName +'.jpg').replace("silver_300x.jpg", currentTierName +'.jpg');
              //console.log("p"+file_url);
                html = html.replace( /__IMG_CART__/g , file_url); 
              
              
              break;
          }
          // let tier = document.getElementById("tier");
          //  let next_tier = document.getElementById("next_tier");
           let tier_array = ['Silver','Gold','Platinum'];
          console.log(tier_array);
           
           if(tier_array[0]==tiers){
            next_tier = tier_array[1];
            html = html.replace( /__nextTierName__/g , next_tier ? next_tier : ''); 
           }
           else if(tier_array[1]==tiers){
            next_tier = tier_array[2];
             html = html.replace( /__nextTierName__/g , next_tier ? next_tier : ''); 
             
           }
           else {
            next_tier = tier_array[0];
             html = html.replace( /__nextTierName__/g , next_tier ? next_tier : ''); 
           }
         html = html.replace( /__currentTierName__/g , tiers ? tiers : '');
         let balance =  json[1][0].lifetime_balance
          if(balance<10000) {
            let current_balance =  10000-balance;
            html = html.replace( /__NEED_POINTS__/g , current_balance);
          }
          else if(balance>=10000 && balance<=30000){
            let current_balance =  30000-balance;
            html = html.replace( /__NEED_POINTS__/g , current_balance);
            
          }
          else{
            let current_balance = 30000-balance;
            html = html.replace( /__NEED_POINTS__/g , current_balance);
          //  document.getElementById('final').style.display = "none";
           
          }
          
        // tier.innerHTML = tiers;
		 //  let currentTierName = json.currentTierName ? json.currentTierName.toLowerCase() : 'silver';
		 //  let file_url = $('[data-fileUrl]').attr("data-fileUrl").replace("silver.jpg", currentTierName +'.jpg').replace("silver_300x.jpg", currentTierName +'.jpg')
   //        html = html.replace( /__IMG_CART__/g , file_url); 
          //  html = html.replace( /__currentTierName__/g , tiers ? tiers : '');  
         // console.log(html.replace( /__currentTierName__/g , json.tiers ? json.tiers : ''));
         //   html = html.replace( /__nextTierName__/g , json.next_tier ? json.next_tier : ''); 
		 //   if ( json.currentBalance ) {
		 // var need_points = json.nextTierPointsRequired - json.currentBalance;
		 //  }
   //       html = html.replace( /__NEED_POINTS__/g , need_points); 
          $('.barcodeImageURL').attr("src", json[2][0].images.f1D ? json[2][0].images.f1D : ''); 


          $('.loyalty_noCustomer_all').html(html);
          $('.loyalty_bot_text_0').hide();
          $('.loyalty_bot_text_1').show();
   //        if ( json.nextTierPointsRequired && json.nextTierPointsRequired > 0) {
			// 	$('.loyalty_bot_text_0').hide();
		 //  } else {
			// 	$('.loyalty_bot_text_1').hide();
		 //  }
		 //  if ( json.currentBalance && json.currentBalance >= 30000 ) {
			// $('.loyalty_bot_text_1').hide();
			// $('.loyalty_bot_text_0').hide();
		 //  }

		  $('.loyalty_noCustomer_all').show();

          */
        }

      }
    });
  }
})();


// Address forms. Add limitation for address fileds

$(function() {
  $('.js-address-form form input[name*="address[address"]').on('keypress', function(e) {
    
    let input = String.fromCharCode(e.keyCode);
    let elem = $(this).siblings('.letter-restricted');
    if(!/[a-zA-Z0-9- ,.'\"]/.test(input)) {
      let textRestrict = 'You can use numbers and English letters only';
      if(!elem.length) $(this).before('<div class="letter-restricted">'+textRestrict+'</div>');
      return false;
    }
    else if(elem.length) elem.remove();
    
    let elemOversize = $(this).siblings('.oversize-restricted');
    let textOversize = 'You have reached 50 characters limit';
    let inputLength = $(this).val().length;
    if(inputLength >= 50) {
      if(!elemOversize.length) $(this).before('<div class="oversize-restricted">'+textOversize+'</div>');
      return false;
    }
    else if(elemOversize.length) elemOversize.remove();
    
  });
});


// Header Search icon. Open search field by clicking on icon

$(function() {
  if($(window).width() < 960 && $(window).width() > 767)  {
    $('.header_mob_search_icon').on('click', function() {
      if($(window).width() < 960 && $(window).width() > 767 && $(this).siblings('.menu_row_search').length) {
        $(this).siblings('.menu_row_search').show();
        $(this).hide();
      }
    });
    $('body').on('click', function(e) {
      if(!$(e.target).closest('.header-item--left').length || $(e.target).closest('.drawer_menu_icon').length) {
        $('.header_mob_search_icon').show();
        $('.header_mob_search_icon').siblings('.menu_row_search').hide();
      }
    });
  }
});